import { Select, Pagination as AntPagination } from "antd";

import styles from "./stylesPagination.module.css";
import { AppStrings } from "../../../utils/constants/AppStrings";

function Pagination({
  total,
  pageSize,
  currentPage,
  onPageSizeChange,
  onPageChange,
  itemLabel = "events",
  pageSizeOptions = [5, 10, 20, 50, 100],
  showPageSizeSelector = true,
  restrictToAdjacentPages = false,
  summaryPrefix = undefined,
  summaryConnector = AppStrings.PAM_PAGINATION_OF,
}) {
  const shouldShowPageSizeSelector =
    showPageSizeSelector && typeof onPageSizeChange === "function";

  const handlePageChange = (page) => {
    if (
      restrictToAdjacentPages &&
      Math.abs(page - currentPage) > 1
    ) {
      return;
    }

    onPageChange?.(page);
  };

  return (
    <div
      className={`${styles.paginationContainer} ${
        shouldShowPageSizeSelector ? "" : styles.paginationOnly
      }`}
    >
      {shouldShowPageSizeSelector && (
        <div className={styles.paginationInfo}>
          {summaryPrefix ? <span>{summaryPrefix}</span> : null}
          <Select
            value={pageSize}
            onChange={onPageSizeChange}
            style={{ width: 75 }}
          >
            {pageSizeOptions.map((option) => (
              <Select.Option key={option} value={option}>
                {option}
              </Select.Option>
            ))}
          </Select>
          {summaryPrefix ? (
            <span>
              {summaryConnector} <strong>{total}</strong>
            </span>
          ) : (
            <span>
              {AppStrings.PER_PAGE_OF} {total} {itemLabel}
            </span>
          )}
        </div>
      )}
      <AntPagination
        current={currentPage}
        total={total}
        pageSize={pageSize}
        showSizeChanger={false}
        onChange={handlePageChange}
        itemRender={(page, type, originalElement) => {
          if (type === "page") {
            const isDisabled =
              restrictToAdjacentPages &&
              Math.abs(page - currentPage) > 1;

            return (
              <span
                className={`${styles.pageNumber} ${
                  page === currentPage ? styles.activePage : ""
                } ${isDisabled ? styles.disabledPage : ""}`}
              >
                {page}
              </span>
            );
          }

          if (type === "prev") {
            return (
              <span className={styles.navWithText}>
                {originalElement}
                <span>{AppStrings.BACK}</span>
              </span>
            );
          }

          if (type === "next") {
            return (
              <span className={styles.navWithText}>
                <span>{AppStrings.NEXT}</span>
                {originalElement}
              </span>
            );
          }

          return originalElement;
        }}
      />
    </div>
  );
}

export default Pagination;
